var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send_mail",
    "data-name": "send mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.111,
    height: 13.523,
    viewBox: "0 0 14.111 13.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34169",
    "data-name": "Path 34169",
    d: "M8.75,17.612v2.727a.441.441,0,0,0,.8.261l1.6-2.171Z",
    transform: "translate(-3.605 -7.257)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34170",
    "data-name": "Path 34170",
    d: "M13.926.082a.441.441,0,0,0-.46-.032L.237,6.958A.441.441,0,0,0,.3,7.767L3.976,9.024l7.832-6.7-6.061,7.3,6.164,2.107a.451.451,0,0,0,.142.024.441.441,0,0,0,.436-.376L14.106.506a.442.442,0,0,0-.181-.425Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/sendMail.06d05dd8eb3ddf9314278cee654dc2b9.svg";
export { ForwardRef as ReactComponent };